// extracted by mini-css-extract-plugin
module.exports = {"Deadline":"Deadline_Deadline__aZJAK","silver":"Deadline_silver__czv0B","yellow":"Deadline_yellow__NYUzh","orange":"Deadline_orange__luGWm","red":"Deadline_red__k2RSj"};